export default "/assets/images/peacekeeper-2.49765913d0e37c20.png";